import { queryOptions } from "@tanstack/react-query";
import { fetcher } from "@/lib/api";
import type { AuthoringResponse } from "./types";

/**
 * `GET /v1/contest-platform/authoring` (`EX-STF01`, `docs/29` §10): the rounds
 * that name the caller as an author. A module of its own so the menu's
 * prefetch (`features/dashboard/prefetch.ts`) can start the Studio home's copy
 * of it without carrying the contest hooks into the menu's bundle.
 */

export const AUTHORING_KEY = ["contest-platform", "authoring"] as const;

export async function fetchAuthoring(): Promise<AuthoringResponse> {
  const res = await fetcher<AuthoringResponse>("/v1/contest-platform/authoring");
  if (!res.success) throw new Error(res.error.message);
  return res.data;
}

export function authoringQuery() {
  return queryOptions({ queryKey: AUTHORING_KEY, queryFn: fetchAuthoring, staleTime: 30 * 1000, retry: false });
}
